import env from '@travel/env';

__webpack_public_path__ =
  process.env.NODE_ENV === 'production' ? `${env('UNIVERSAL_ASSETS_PATH')}/` || '/' : '/';
